module.exports = __webpack_public_path__ + "static/media/globe_blank.1991a160.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/globe_blank.png
// module id = 168
// module chunks = 0